import moment from 'moment';
import FormModels from './FormModels.constants';
import PdfMake from './PdfMake.constants';
import * as TableDefaults from './TableDefaults.constants';
import DataTableRefs from './DataTableRefs.constants';

const alphanumericOnlyRegex = /^[a-z0-9]+$/i;
const bankAccountNumberRegex = /^[\d\s-]+$/;
const dateFormat = 'MM/DD/YYYY';
const dateFormatYYYYMMDD = 'YYYY-MM-DD';
const datePickerFormat = 'YYYY-MM-DD';
const dateTransactionFormat = 'MMM Do, YYYY';
const dateTransactionAbbrevFormat = 'MMM D';
const dateRegex = /^(0?[1-9]|1[012])[\/\-.]?(0?[1-9]|1[0-9]|2[0-9]|3[01])[\/\-.]?(\d{4})$/;
const dateReplacePattern = (match, month, day, year) => {
  let matchValid = moment(match, dateFormat).isValid(),
    monthFormatted = moment(match, dateFormat).format('MM'),
    dayFormatted = moment(match, dateFormat).format('DD');
  if (!matchValid) {
    return match;
  }
  return `${monthFormatted}/${dayFormatted}/${year}`;
};
const datePickerReplacePattern = (match, month, day, year) => {
  let date = `${year}-${month}-${day}`;
  return year.length === 2
    ? moment(date, 'YY-MM-DD').format(datePickerFormat)
    : date;
};
const dayAbbrevFormat = 'ddd';
const digitsOnlyRegex = /[^0-9]+/g;
const emailRegex = /(^(?!.*\.\.)$|^(?!.*\.\.)(([^<>()[\]\\.;:\s@'"]+(\.[^<>()[\]\\.;:\s@'"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|((?!-)(?!.*--)([a-zA-Z0-9\._]+)+\.[a-zA-Z]{1,}))$)/;
const multipleSpacesRegex = /\s{2,}/g;
const multipleDashesRegex = /-{2,}/g;
const phoneRegexLength = /^\(?(\d){3}\)?[-. ]?(\d{3})[-. ]?(\d{4})$/;
const phoneRegex = /^\(?([2-9]\d\d)\)?[-. ]?(\d{3})[-. ]?(\d{4})$/;
const phoneReplacePattern = '($1) $2-$3';
const ssnRegex = /^\(?(\d{3})\)?[- ]?(\d{2})[- ]?(\d{4})$/;
const ssnReplacePattern = '$1-$2-$3';
const ssnMaskPattern = 'XXX-XX-$3';

const phoneObfuscateRegex = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
const phoneObfuscateReplacePattern = '$1-$2-$3';
const phoneObfuscateMaskPattern = '###-###-$3';

const emailObfuscateRegex = /(.)(.+)[@](.+)$/;
const emailObfuscateMaskPattern = (match, first, second, third) => {
  let mask = '';
  for (let i = 0; i < second.length; i++) {
    mask = mask + '#';
  }
  return `${first}${mask}@${third}`;
};

const yearFormat = 'YYYY';
const zipRegex = /^(\d{5})(?:[-. ]?(\d{4}))?$/;
const zipReplacePattern = (match, p1, p2) => {
  return p2 ? `${p1}-${p2}` : p1;
};
const dialogMaxWidth = '360px';
const pickerMaxWidth = '290px';
const routePrefix = 'route:';
const modalPrefix = 'modal:';
const credentialsRegex = /^[a-zA-Z0-9^$*.[\]{}()?\-"!@#%&/\\,><';|_~`]+$/;
const specialCharRegex = /[$^*.[\]{}()?\-"!@#%&/\\,><';|_~`]/;
const upperLowerRegex = /^(?=.*[a-z])(?=.*[A-Z]).*$/;
const evaultCategoryKey = {
  1: 'documents_label_medical',
  2: 'documents_label_drug',
  3: 'documents_label_dental',
  4: 'documents_label_day-care',
  5: 'documents_label_premium',
  6: 'documents_label_transportation',
  7: 'documents_label_other',
  8: 'documents_label_non-claim-document',
};

const PRIMARY_BENEFICIARY = 'Primary';
const CONTINGENT_BENEFICIARY = 'Contingent';

const SELECT_ALL_VALUE = '*';
const ASCENDING_SYMBOL = '+';
const ASCENDING = 'asc';
const DESCENDING_SYMBOL = '-';

const FDIC_PLAN = '104';

const MEMBER_MIGRATED_ROLE = 'MemberMigrated';

const SYSTEM_HIGH_DATE = '2999-12-31';

export {
  alphanumericOnlyRegex,
  phoneObfuscateRegex,
  phoneObfuscateReplacePattern,
  phoneObfuscateMaskPattern,
  emailObfuscateRegex,
  emailObfuscateMaskPattern,
  bankAccountNumberRegex,
  dateFormat,
  dateFormatYYYYMMDD,
  datePickerFormat,
  dateTransactionFormat,
  dateTransactionAbbrevFormat,
  dateRegex,
  dateReplacePattern,
  datePickerReplacePattern,
  dayAbbrevFormat,
  dialogMaxWidth,
  emailRegex,
  pickerMaxWidth,
  digitsOnlyRegex,
  multipleSpacesRegex,
  multipleDashesRegex,
  phoneRegexLength,
  phoneRegex,
  phoneReplacePattern,
  ssnRegex,
  ssnReplacePattern,
  ssnMaskPattern,
  yearFormat,
  zipRegex,
  zipReplacePattern,
  routePrefix,
  modalPrefix,
  credentialsRegex,
  specialCharRegex,
  upperLowerRegex,
  evaultCategoryKey,
  FormModels,
  PRIMARY_BENEFICIARY,
  CONTINGENT_BENEFICIARY,
  PdfMake,
  TableDefaults,
  DataTableRefs,
  SELECT_ALL_VALUE,
  ASCENDING,
  ASCENDING_SYMBOL,
  DESCENDING_SYMBOL,
  FDIC_PLAN,
  MEMBER_MIGRATED_ROLE,
  SYSTEM_HIGH_DATE,
};
